require("./visualMapContinuous");

require("./visualMapPiecewise");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/component/visualMap.js
// module id = tQk0
// module chunks = 0 1